"use client";
import React, { useState } from "react";
import { Input } from "../atoms/input";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

interface PasswordInputProps {
  register: any;
  placeholder: string;
  id: string;
  className?: string;
}

export function PasswordInput({
  register,
  placeholder,
  id,
  className,
}: PasswordInputProps) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <>
      <div className={`pt-2 relative ${className}`}>
        <Input
          {...register}
          type={showPassword ? "text" : "password"}
          id={id}
          placeholder={placeholder}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center mt-2 mr-3"
          onClick={togglePasswordVisibility}>
          {showPassword ? (
            <EyeIcon className="w-4 h-4" />
          ) : (
            <EyeSlashIcon className="w-4 h-4" />
          )}
        </button>
      </div>
    </>
  );
}
